import React from 'react';
import { TextInput, StyleSheet } from 'react-native';
import { XStack } from '@tamagui/stacks';
import { Search } from 'lucide-react-native';
import { COLORS } from '@/constants/colors';

type SearchBarProps = {
  value: string;
  onChangeText: (text: string) => void;
  isDark?: boolean;
};

const SearchBar = React.memo<SearchBarProps>(({ value, onChangeText, isDark }) => {
  const bgColor = isDark ? COLORS.ZINC_900 : '#F0F0F0';
  const textColor = isDark ? COLORS.WHITE : COLORS.DARK_TEXT;
  const placeholderColor = isDark ? COLORS.GRAY_400 : COLORS.GRAY_500;

  return (
    <XStack
      alignItems="center"
      gap="$2"
      paddingHorizontal="$3"
      paddingVertical="$2"
      borderRadius={12}
      backgroundColor={bgColor}
    >
      <Search size={20} color={placeholderColor} />
      <TextInput
        value={value}
        onChangeText={onChangeText}
        placeholder="Wyszukaj..."
        placeholderTextColor={placeholderColor}
        style={[styles.input, { color: textColor }]}
      />
    </XStack>
  );
});

const styles = StyleSheet.create({
  input: {
    flex: 1,
    fontSize: 16,
    padding: 0,
  },
});

SearchBar.displayName = 'SearchBar';

export default SearchBar;

